import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavComponent } from '../../components/nav.component/nav.component';
import { FooterComponent } from '../../components/footer.component/footer.component';

@Component({
  selector: 'app-cookies.component',
  imports: [
    CommonModule,
    RouterModule,
    NavComponent,
    FooterComponent,
  ],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss',
})
export class CookiesComponent {
  lastUpdated = 'October 10, 2026';
}
